export function isOpaqueStudioContextId(value: string): boolean {
  const normalized = value.trim();
  return (
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      normalized,
    ) ||
    /^[0-9A-HJKMNP-TV-Z]{26}$/i.test(normalized) ||
    /^[0-9a-f]{24,}$/i.test(normalized) ||
    /^(?:block|component|element|flow|item|node|page|section)[-_](?:[0-9a-f]{16,}|[0-9A-HJKMNP-TV-Z]{16,}|[0-9]{8,})$/i.test(
      normalized,
    )
  );
}

export function presentStudioContextName(
  value: string,
  fallback: string,
): string {
  if (isOpaqueStudioContextId(value)) return fallback;
  if (!/^[a-z0-9]+(?:[-_][a-z0-9]+)+$/.test(value)) return value;
  return value
    .split(/[-_]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
